/* AUTO-GENERATED by scripts/build-default-output-snapshot.mjs — DO NOT EDIT.
 *
 * The REAL stdout of DEFAULT_CODE (src/data/snippets.ts) on PHP 8.4, captured at
 * build time against the same php-wasm runtime the browser uses. The app seeds
 * this into the output pane on first paint so a tool-first visitor lands on
 * output already on screen — WITHOUT downloading the engine (protects LCP). It is
 * replaced the moment the user edits the code or a real run produces output.
 * Regenerate via `pnpm build:snapshot` after changing DEFAULT_CODE/runtime. */

import type { RunResult } from '../runtime/run-result';

export const DEFAULT_OUTPUT_SNAPSHOT_VERSION = "8.4";

export const DEFAULT_OUTPUT_SNAPSHOT: RunResult = {
  "stdout": "Hello from php.onl! 🐘\nRunning PHP 8.4.20\nCurrent year: 2026.\n",
  "stderr": "",
  "exitCode": 0,
  "timeMs": 110,
  "memBytes": 417768
};
